import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-candidates-page',
  templateUrl: './candidates-page.component.html',
  styleUrls: ['./candidates-page.component.css']
})
export class CandidatesPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
